var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutBlob1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 420,
    height: 290.811,
    viewBox: "0 0 420 290.811",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Watercolor blob",
    filter: "url(#filter0_f_0_27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M188.276 38C238.966 19 311.379 31.6667 340.345 76C376.552 126.667 347.586 164.667 376.552 202.667C398.276 240.667 340.345 272.333 275.172 266C217.241 259.667 181.034 240.667 123.103 247C65.1724 253.333 28.9655 209 43.4483 164.667C57.931 120.333 130.345 63.3333 188.276 38Z",
    fill: "url(#paint0_linear_0_27)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_27",
    x: -24,
    y: -24,
    width: 468,
    height: 333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_0_27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_27",
    x1: 40.2547,
    y1: 29.45,
    x2: 199.258,
    y2: 257.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E4FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutBlob1);
export default __webpack_public_path__ + "static/media/about-blob-1.b0ba24d7c46a8874b4b2941f21fcea51.svg";
export { ForwardRef as ReactComponent };